<template>
	<div class="rebag" v-cloak>
		<HeaDer></HeaDer>
		<div class="bgcontent">
			<div class="box-card">
				<div class="boxbg">
					<p>网上考试报名系统</p>
				</div>
				<div class="boxtext">
					<div style="min-height: 550px; position: relative">
						<div class="textleft">
							<el-table :data="tableData" style="width: 100%; font-size: 16px">
								<el-table-column prop="examinationName" label="考试名称">
								</el-table-column>
								<el-table-column prop="examineBeginDate" label="报名时间">
									<template v-slot="scope">
										{{ scope.row.signUpBeginDate }} 至
										{{ scope.row.signUpEndDate }}
									</template>
								</el-table-column>

								<el-table-column prop="status" label="">
									<template v-slot="scope">
										<el-button type="primary" @click="goLogin(scope.row.id)"
											v-if="scope.row.state == 0" style="margin-left: 15%; width: 126px">开始报名
										</el-button>
										<el-button type="primary" @click="goLogin(scope.row.id)"
											v-if="scope.row.state != 0" style="margin-left: 15%; width: 126px">报名已经结束
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="textright">
							<img src="../assets/pen.png" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<FooTer></FooTer>
		<!--		<footer>-->
		<!--			<Span>版权所有：中智云达 2020-2025 All Rights Reserved.</Span>-->
		<!--			<span class="kfoter">地址：条山街区委家属院</span>-->
		<!--			<span>ICP证:晋ICP备12002626号 </span>-->
		<!--		</footer>-->
	</div>
</template>

<script>
	import HeaDer from "../components/common/header.vue";
	import config from "@/util/config";
	import FooTer from "../components/common/footer.vue";
	import {
		examList
	} from "@/api/api";
	export default {
		name: "baomingtable",
		components: {
			HeaDer,
			FooTer,
		},
		data() {
			return {
				tableData: [],
			};
		},
		created() {
			this.$store.commit("setBaseUrl", config.host);
			examList({"examinationName":"万荣县"}).then(res => {
				console.log(res)
				this.tableData = res.data.data.filter(item=>item.state===0)
			})
			this.$store.commit('updateToken', '');
			this.$store.commit('userexaminfo', '');
		},
		methods: {
			goLogin(id) {
				this.$router.push({
					path: "/register",
					query: {
						id: id,
					},
				});
			},
		},
	};
</script>

<style scoped>
	body {
		background: url(../assets/dabg.png) top center no-repeat;
		background-size: cover;
		background-repeat: no-repeat;
		background-attachment: fixed;
		background-position: top;
		bottom: 0px !important;
	}

	@media screen and (min-width: 1000px) {
		.rebag {
			float: left;
			width: 100%;
		}
	}

	@media screen and (max-width: 1000px) {
		.rebag {
			/*border: 1px solid red;*/
			float: left;
		}
	}

	.bgcontent {
		margin-top: 40px;
	}

	.box-card {
		margin: 0 auto;
		width: 1400px;
		margin: 0 auto;
		min-height: 680px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
	}

	.yuetitle {
		font-size: 20px;
		color: #cc060a;
		font-weight: bold;
	}

	.mingxi {
		padding: 0 50px;
	}

	.mingxi p {
		text-align: left;
		font-size: 15px;
		line-height: 34px;
	}

	.boxbg {
		background: url(../assets/bc.png);
		width: 100%;
		height: 110px;
		float: left;
		background-size: cover;
	}

	.boxbg p {
		font-size: 24px;
		line-height: 70px;
		font-weight: bold;
		color: #003493;
		text-align: left;
		padding-left: 50px;
		letter-spacing: 2px;
	}

	.boxtext {
		width: 100%;
		min-height: 520px;
		float: left;
		padding-top: 20px;
	}

	.boxtext li {
		text-align: left;
		line-height: 44px;
		padding-left: 50px;
		border-bottom: 1px solid #ececec;
	}

	.textright img {
		width: 200px;
		height: 200px;
		position: absolute;
		right: 20px;
		bottom: 10px;
	}

	.textleft {
		width: 1200px;
		margin: 0 auto;
	}

	.fanhui {
		border: 1px solid #999999;
		color: #999999;
		background-color: #ffffff;
		margin-right: 30px;
	}

	.yuefu {
		border: 1px solid #0099ff;
		color: #fff;
		background-color: #0099ff;
		margin-right: 30px;
	}

	.kfoter {
		margin: 0px 20px;
	}
</style>
